import { render, staticRenderFns } from "./custom-icon-vorzeitig-garantiert.vue?vue&type=template&id=2b9d84fb"
import script from "./custom-icon-vorzeitig-garantiert.vue?vue&type=script&lang=js"
export * from "./custom-icon-vorzeitig-garantiert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports